import { NgModule } from "@angular/core";
import { AppMenuComponent } from "./app-menu/app-menu.component";
import { SharedModule } from "@deltager/organizers/admin/shared/shared.module";
import { MaterialUiModule } from "@deltager/organizers/admin/core/material-ui/material-ui.module";
import { AppMenuItemComponent } from "./app-menu-item/app-menu-item.component";

@NgModule({
  imports: [SharedModule, MaterialUiModule],
  exports: [AppMenuComponent],
  declarations: [AppMenuComponent, AppMenuItemComponent]
})
export class AppMenuModule {}
